var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { blackAreaIcons, blackKidIcons } from '@/support/Icon';
import Storage from '@/support/Storage';
import { Subject } from '@/models/Subject';
import ErrorHandler from '@/support/ErrorHandler';
import { fileToBase64 } from '@/support/String';
import { UserFile } from '@/models/UserFile';
import { Student } from '@/models/Student';
import AsyncSelect from '@/components/async-select/AsyncSelect';
import { RolesEnum } from '@/items/Roles';
let ScoolfolioDialog = class ScoolfolioDialog extends Vue {
    constructor() {
        super(...arguments);
        this.selectedArea = new Subject();
        this.selectedTopic = new Subject();
        this.selectedSubject = null;
        this.defaultSubject = null;
        this.topics = [];
        this.subjects = [];
        this.fileString = '';
        this.fileName = '';
        this.inputElement = null;
        this.isAddingGoal = false;
        this.isAddingOther = false;
        this.isShowingOptions = false;
        this.isDisplayingFileDialog = false;
        this.isDocument = false;
        this.rules = {
            description: (value) => value.length <= 75 || 'Can\'t be longer then 75 characters',
        };
    }
    get currentCurriculum() {
        return this.$store.state.curriculum;
    }
    get dialogOptions() {
        return {
            title: this.$t('portfolio.dialog.fileSizeExceededTitle').toString(),
            text: this.$t('portfolio.dialog.fileSizeExceededMessage').toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.ok').toString(),
                    action: () => {
                        this.file = null;
                        this.fileString = '';
                        this.fileName = '';
                        if (this.inputElement) {
                            this.inputElement.removeAttribute('value');
                            this.inputElement.setAttribute('value', '');
                        }
                    },
                },
            },
        };
    }
    get SubjectModel() {
        if (!this.selectedTopic) {
            return null;
        }
        return new Subject().include('parent').filter('parents', this.selectedTopic.id);
    }
    get icons() {
        const type = Storage.get('type');
        return type && type.toLowerCase() === 'po' ? blackAreaIcons : blackKidIcons;
    }
    mounted() { }
    destroyed() {
        this.defaultSubject = null;
    }
    getAreaChildren(id) {
        if (!this.currentCurriculum || !this.currentCurriculum.subjects) {
            return '';
        }
        let topics = [];
        const subjects = this.currentCurriculum.subjects;
        const area = subjects.find((area) => {
            return area.id === id;
        });
        if (area && area.children) {
            topics = [...topics, ...area.children];
        }
        this.$set(this, 'topics', topics);
        if (this.topic) {
            this.selectedSubject = null;
            const topic = this.topics.find((topic) => {
                return topic.id === this.topic;
            });
            if (topic) {
                this.selectedTopic = topic;
            }
        }
    }
    inputChanged(event) {
        const files = event.target.files;
        this.inputElement = event.target;
        if (files === null || !files.length) {
            return;
        }
        if (this.calculateFileSize(files[0].size) > 250) {
            this.isDisplayingFileDialog = true;
            return;
        }
        fileToBase64(files[0]).then((encodedFile) => {
            this.fileString = encodedFile;
        });
        this.file = files[0];
        this.file.type.includes('application/vnd.openxmlformats-officedocument') ? this.isDocument = true : this.isDocument = false;
    }
    getTempFile() {
        if (!this.fileString.length) {
            return '';
        }
        return this.fileString;
    }
    createPayload() {
        return {
            file: this.file,
            name: this.fileName,
            meta: {
                subject: this.selectedSubject.value,
            },
        };
    }
    createWithACL() {
        if (!this.file) {
            return;
        }
        new UserFile()
            .user(this.student)
            .createWithACL(this.file, this.fileName, [RolesEnum.TEACHER, RolesEnum.ADMIN, RolesEnum.TRAINER, RolesEnum.ROOT])
            .then((response) => {
            if (response) {
                this.clear();
                this.$emit('input', false);
                this.$emit('uploaded');
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    clear() {
        this.selectedArea = new Subject();
        this.selectedTopic = new Subject();
        this.selectedSubject = null;
        this.topics = [];
        this.subjects = [];
        this.file = null;
        this.fileString = '';
        this.fileName = '';
        if (this.inputElement) {
            this.inputElement.removeAttribute('value');
            this.inputElement.setAttribute('value', '');
        }
        this.isAddingGoal = false;
        this.isAddingOther = false;
        this.isShowingOptions = false;
    }
    create() {
        if (!this.student) {
            return;
        }
        if (!this.isAddingGoal) {
            this.createWithACL();
            return;
        }
        new UserFile()
            .user(this.student)
            .include(['user', 'subject'])
            .create(this.createPayload())
            .then((response) => {
            if (response) {
                this.clear();
                this.$emit('input', false);
                this.$emit('uploaded');
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
        // file.file = this.file;
        // file.meta = {subject: this.selectedSubject.id};
        // file.create()
        // .then((response: any) => {
        // });
    }
    getTopicChildren(topicId) {
        if (!this.selectedTopic) {
            return [];
        }
        this.selectedSubject = null;
        new Subject()
            .limit(1000)
            .include('parent')
            .filter('parents', topicId)
            .all()
            .then((subjects) => {
            this.$set(this, 'subjects', subjects);
            if (this.subject) {
                this.setSubject();
            }
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    close() {
        this.$emit('input', false);
        this.isAddingGoal = false;
        this.isAddingOther = false;
        this.isShowingOptions = false;
    }
    areaSelected(area) {
        if (!area.id) {
            return;
        }
        this.selectedTopic = new Subject();
        this.selectedSubject = null;
        this.getAreaChildren(area.id);
    }
    topicSelected(topic) {
        if (!topic.id) {
            return;
        }
        this.selectedSubject = null;
        this.getTopicChildren(topic.id);
    }
    setSubject() {
        if (this.subject) {
            const subject = this.subjects.find((subject) => {
                return subject.id === this.subject;
            });
            if (subject) {
                this.$set(this, 'defaultSubject', {
                    text: subject.name,
                    value: subject.id,
                });
                // this.$set(this, 'selectedSubject', {
                //   text: subject.name,
                //   value: subject.id,
                // });
            }
        }
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([RolesEnum.ADMIN, RolesEnum.ROOT, RolesEnum.TRAINER, RolesEnum.TEACHER]);
    }
    areaChanged(areaId) {
        if (areaId.length) {
            this.selectedArea = this.$store.state.curriculum.subjects.find((subject) => {
                return subject.id === areaId;
            });
        }
    }
    topicChanged(topicId) {
        if (topicId.length) {
        }
    }
    calculateFileSize(bytes) {
        return Math.ceil(bytes / 1000000);
    }
};
__decorate([
    Prop({ default: null }),
    __metadata("design:type", typeof (_a = typeof Student !== "undefined" && Student) === "function" ? _a : Object)
], ScoolfolioDialog.prototype, "student", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], ScoolfolioDialog.prototype, "area", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], ScoolfolioDialog.prototype, "topic", void 0);
__decorate([
    Prop(),
    __metadata("design:type", String)
], ScoolfolioDialog.prototype, "subject", void 0);
__decorate([
    Watch('selectedArea'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_b = typeof Subject !== "undefined" && Subject) === "function" ? _b : Object]),
    __metadata("design:returntype", void 0)
], ScoolfolioDialog.prototype, "areaSelected", null);
__decorate([
    Watch('selectedTopic'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [typeof (_c = typeof Subject !== "undefined" && Subject) === "function" ? _c : Object]),
    __metadata("design:returntype", void 0)
], ScoolfolioDialog.prototype, "topicSelected", null);
__decorate([
    Watch('area'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ScoolfolioDialog.prototype, "areaChanged", null);
__decorate([
    Watch('topic'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ScoolfolioDialog.prototype, "topicChanged", null);
ScoolfolioDialog = __decorate([
    Component({
        components: {
            AsyncSelect,
        },
    })
], ScoolfolioDialog);
export default ScoolfolioDialog;
